import { render, staticRenderFns } from "./modalEditUserReservations.vue?vue&type=template&id=0bbe882e&scoped=true&"
import script from "./modalEditUserReservations.vue?vue&type=script&lang=js&"
export * from "./modalEditUserReservations.vue?vue&type=script&lang=js&"
import style0 from "./modalEditUserReservations.vue?vue&type=style&index=0&id=0bbe882e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbe882e",
  null
  
)

export default component.exports